import DimensionIcon from './DimensionIcon';
import Stack from './Stack';
import styled from 'styled-components';

const BrandBadgeWrapper = styled(Stack).attrs(
    ({ $space = '.25rem', $direction = 'row' }) => ({
        $space,
        $direction,
    }),
)`
    font-family: ${({ theme }) => theme.style_primary};
    letter-spacing: normal;
    text-transform: capitalize;
    display: inline-flex;
    align-items: center;
    font-size: 0.875rem;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    border-radius: 100px;
    background-color: rgba(128, 128, 128, 0.1);
    padding: 0 0.375rem;
`;

function BrandBadge({ name }) {
    return (
        <BrandBadgeWrapper>
            <DimensionIcon dimensionType="brand" />
            <span>{name}</span>
        </BrandBadgeWrapper>
    );
}

export default BrandBadge;
